import { styled } from '@vebox/etui-system';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { createElement } from 'react';
import '../utilities/get-styleprop.js';
import '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import { icons } from '../Icon/icons.js';
import '../Icon/helper.js';
import '@vebox/etui-colors';
import '../ClickOutside/ClickOutside.js';
import Tooltip from '../Tooltip/Tooltip.js';
import Button from '../Button/Button.js';

const FieldRoot = styled(Div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid ${({
  theme
}) => theme.spacing.xs}px;
  padding: 0 ${({
  theme
}) => theme.spacing.xs}px;
`;

const Field = ({
  children,
  onUpClick,
  onDownClick,
  isUpDisabled,
  isDownDisabled,
  showDownDisabledMessage,
  downDisabledMessage,
  showUpDisabledMessage,
  upDisabledMessage
}) => {
  return /*#__PURE__*/createElement(FieldRoot, null, /*#__PURE__*/createElement(Tooltip, {
    disableToolTip: !showUpDisabledMessage || !isUpDisabled,
    message: upDisabledMessage,
    placement: "top"
  }, /*#__PURE__*/createElement(Button, {
    iconOnly: true,
    iconProps: {
      glyph: icons.CHEVRON_DOWN,
      rotate: 180
    },
    onClick: onUpClick,
    disabled: isUpDisabled,
    tabIndex: -1
  })), children, /*#__PURE__*/createElement(Tooltip, {
    disableToolTip: !showDownDisabledMessage || !isDownDisabled,
    message: downDisabledMessage,
    placement: "top"
  }, /*#__PURE__*/createElement(Button, {
    iconOnly: true,
    iconProps: {
      glyph: icons.CHEVRON_DOWN
    },
    onClick: onDownClick,
    disabled: isDownDisabled,
    tabIndex: -1
  })));
};

export default Field;
